export default "__VITE_ASSET__DvaTSYSx__"